export default __webpack_public_path__ + "static/media/guitar_direct.32838b12.png";